import styled, { css } from 'styled-components';

import { Typography } from '@/components/Typography';

import { Box } from '../Box';
import { Modal as BaseModal } from '../Modal';

export const Title = styled(Typography)`
  text-transform: uppercase;
  text-align: center;

  ${({ theme }) => css`
    font-weight: ${theme.components.newsLetter.titleFontWeight};
    font-family: ${theme.fontFamilies.italianPlate};
    font-size: ${theme.components.newsLetter.titleFontSize};
    margin: 0 ${theme.spacing(2)} ${theme.spacing(2)};
  `}
`;

export const Body = styled(Box)`
  ${({ theme }) => css`
    font-weight: ${theme.fontWeights.regular};
    margin: 0 ${theme.spacing(1)};
    scale: ${theme.fontSizes.p0};
    line-height: ${theme.lineHeights.p0};
  `}
`;

export const Modal = styled(BaseModal)`
  && {
    ${({ theme }) => css`
      display: flex;
      flex-direction: column;
      height: 100%;
      max-height: 100%;
      margin: 0;
      padding-block: ${theme.spacing(3, 0)};
      ${theme.media.sm.up} {
        display: block;
        flex-direction: unset;
        height: fit-content;
      }
    `}
  }
`;

export const ModalBody = styled(BaseModal.Body)`
  flex: 1;
  ${({ theme }) => css`
    padding-inline: ${theme.spacing(2)};
    ${theme.media.sm.up} {
      padding-inline: ${theme.spacing(3)};
    }
    form {
      p {
        ${css`
          font-family: ${theme.fonts.paragraphFont};
        `}
      }
    }
  `};
`;

export const ModalTail = styled(BaseModal.Tail)`
  ${({ theme }) => css`
    ${!theme.components.newsLetter.visibleTail &&
    css`
      display: none;
    `}
  `}
`;
export const ModalTailButton = styled.button`
  background: inherit;
  padding: 0;
`;

export const SuccessMessage = styled(Typography)`
  ${({ theme }) => css`
    font-family: ${theme.fonts.paragraphFont};
    ${theme.components.newsLetter.successMessage.fontSize &&
    css`
      font-size: ${theme.components.newsLetter.successMessage.fontSize};
    `}
    text-align: ${theme.components.newsLetter.successMessage.textAlignMobile};
    margin: ${theme.components.newsLetter.successMessage.marginMobile};
    ${theme.media.sm.up} {
      text-align: ${theme.components.newsLetter.successMessage.textAlign};
      margin: ${theme.components.newsLetter.successMessage.margin};
    }
    .newsletter-subscribed-title {
      font-family: ${theme.fonts.paragraphFont};
      color: ${theme.components.newsLetter.successMessage.titleColor};
      ${theme.components.newsLetter.successMessage.titleFontSize &&
      css`
        font-size: ${theme.components.newsLetter.successMessage.titleFontSize};
      `}
      ${theme.components.newsLetter.successMessage.titleFontWeight &&
      css`
        font-weight: ${theme.components.newsLetter.successMessage
          .titleFontWeight};
      `}
    }
    .newsletter-subscribed-mailto {
      color: ${theme.colors.darkBlue};
      ${theme.components.newsLetter.successMessage.mailtoTextDecoration &&
      css`
        text-decoration: ${theme.components.newsLetter.successMessage
          .mailtoTextDecoration};
      `}
    }
  `};

  br {
    content: '';
    margin: 1em;
    display: block;
  }
`;
